import { Config } from '../../../shared/config';
const config = new Config();
export async function submitQuizLead(input) {
    const body = {
        firstName: input.lead.firstName,
        email: input.lead.email,
        phone: input.lead.phone,
        company: input.lead.company,
        answers: input.answers,
        verdict: input.verdict,
        result: input.result,
        url: typeof window !== 'undefined' ? window.location.href : undefined,
        referrer: typeof document !== 'undefined' ? document.referrer : undefined,
    };
    try {
        const res = await fetch(`${config.apiUrl}/public/quiz-lead`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        const data = (await res.json().catch(() => ({})));
        if (!res.ok) {
            return { success: false, error: data.error || `HTTP ${res.status}` };
        }
        return { success: true, id: data.id };
    }
    catch (err) {
        return { success: false, error: err instanceof Error ? err.message : 'Network error' };
    }
}
